<div class="row button-container">
    <div class="col-2 custom-button">
        <div *ngIf="enableFeatureCheckbox" class="rSet enable-alo-label">Enable feature
            <input type="checkbox" class="primary-checkbox" id="enable-startup" [checked]="isEnableFeature"
                (change)="enableFeature($event.target.checked)" />
            <label for="enable-startup" aria-label="Enable feature"><span class="extra-border-enablefeat"></span></label>
        </div>
    </div>
    <span class="col-1 aoc-tooltips" *ngIf="defaultColor===false">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span class="col-1 aoc-tooltips" *ngIf="defaultColor===true">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>

    <div class="col-8"></div>
    <div class="col-1"></div>
</div>

<div class="row slider-container">
    <div id="AST-StartupTime-text" class="col-1 label signifyBookmd dim-margin">Startup time</div>
    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
                <span id="AST-StartupTime-STDmin" class=" signifyBookmd minValue"> min {{floorValue}}</span>
            </div>
            <div class="col-3">
                <span id="AST-StartupTime-STDmax" class="signifyBookmd maxValue"> max {{ceilValue}}</span>
            </div>
        </div>
    </div>

    <span id="AST-StartupTime-min" *ngIf="!quickConfigvalue" class="signifyBookmd text-mindim  sliderMinValue col-1">{{floorValue}}</span>
    <div *ngIf="!quickConfigvalue" class="col-6 curvePadding sliderCss" id="sliderClick"
        [ngClass]="{'isResetDisabled': isResetDisabled===true}">
        <ngx-slider type="normalType" [options]=valOptions [(value)]=sliderValue
            (userChangeEnd)="sliderValueChange($event.value)">
        </ngx-slider>
    </div>
    <span id="AST-StartupTime-max" *ngIf="!quickConfigvalue" class="signifyBookmd text-mindim col-1 startUpMargin"
        [ngClass]="{'maxValueCss': quickConfigvalue===true}">{{ceilValue}}</span>

    <div class="row form-group col-3">
        <input id="AST-StartupTime-Input" type="number" [(ngModel)]="textboxValue" (input)="valueChanged($event.target.value)" (keypress)="numberOnly($event)"
            [ngClass]="{'ml-17': quickConfigvalue===true,'myStyle': inputError===true, 'isResetDisabled': isResetDisabled===true, 'inputCssStandard': quickConfigvalue===true}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="isResetDisabled" />

        <p id="AST-StartupTime-Units" class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">{{unit}}</p>
    </div>
</div>
<div *ngIf="quickConfigvalue">
    <br>
</div>
